import React, { createContext, useCallback, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { translations, routes } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const lang = location.pathname.startsWith("/en") ? "en" : "it";
  const t = translations[lang];
  const r = routes[lang];

  const switchLang = useCallback(() => {
    const target = lang === "it" ? "en" : "it";
    let newPath = location.pathname;
    const pairs = [
      ["/it/camere", "/en/rooms"],
      ["/it/esperienza-torino", "/en/turin-experience"],
      ["/it/offerte", "/en/offers"],
      ["/it/servizi", "/en/services"],
      ["/it/chi-siamo", "/en/about"],
      ["/it/contatti", "/en/contact"],
      ["/it", "/en"],
    ];
    for (const [it, en] of pairs) {
      if (target === "en" && newPath.startsWith(it)) {
        newPath = newPath.replace(it, en);
        break;
      }
      if (target === "it" && newPath.startsWith(en)) {
        newPath = newPath.replace(en, it);
        break;
      }
    }
    navigate(newPath || routes[target].home);
  }, [lang, location.pathname, navigate]);

  const value = useMemo(() => ({ lang, t, r, switchLang }), [lang, t, r, switchLang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
